import { makeStyles } from "tss-react/mui";

export type IStyleParams = {
  locale: string;
};

const useStyles = makeStyles<{ params: IStyleParams }>({
  name: "LogoText",
  uniqId: "logo_text",
})((theme, { params }, classes) => {
  return {
    handIcraft: {
      justifyContent: "space-between",
      alignItems: "center",
      margin: "auto",
      order: 1,
    },
    logoTextContainer: {
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
      gap: "0px",
      backgroundSize: "cover",
      minHeight: "900px",
      padding: "50px 0",
      [theme.breakpoints.down("md")]: {
        gridTemplateColumns: "repeat(1, 1fr)",
        padding: "0",
        height: "auto",
      },
    },

    logoText: {
      width: "60%",
      [theme.breakpoints.down("xl")]: {
        width: "90%",
      },
      [theme.breakpoints.down("lg")]: {
        width: "80%",
      },
      [theme.breakpoints.down("md")]: {
        width: "100%",
        padding: "5%",
      },
    },

    handIcraftTitle: {
      fontFamily:
        params.locale === "en-US"
          ? "Montserrat"
          : params.locale === "zh-CN"
          ? "Noto Sans SC"
          : "Noto Sans TC",
      fontWeight: "700",
      fontSize: "40px",
      lineHeight: "57.92px",
      color: "#547FA0",
      letterSpacing: params.locale === "en-US" ? 0 : "8px",

      [theme.breakpoints.down("md")]: {
        fontSize: "24px",
      },
    },
    handIcraftContent: {
      fontFamily:
        params.locale === "en-US"
          ? "Montserrat"
          : params.locale === "zh-CN"
          ? "Noto Sans SC"
          : "Noto Sans TC",
      fontWeight: "500",
      fontSize: "18px",
      lineHeight: "36px",
      padding: "50px 0",
      width: "100%",
      letterSpacing: params.locale === "en-US" ? 0 : "3.6px",
      [theme.breakpoints.down("md")]: {
        fontSize: "16px",
        letterSpacing: params.locale === "en-US" ? 0 : "3.2px",
        textAlign: "justify",
      },
    },
    serviceLink: {
      fontFamily:
        params.locale === "en-US"
          ? "Montserrat"
          : params.locale === "zh-CN"
          ? "Noto Sans SC"
          : "Noto Sans TC",
      fontWeight: "700",
      fontSize: "18px",
      lineHeight: "36px",
      letterSpacing: params.locale === "en-US" ? 0 : "3.6px",

      opacity: "0.6",
      textAlign: "center",
      paddingBottom: "50px",
      display: "flex",
      "&:hover": {
        color: "black",
        opacity: "1",
        cursor: "pointer",
      },
      [theme.breakpoints.down("sm")]: {
        paddingBottom: "0",
      },
    },

    imgLogoInner: {
      backgroundSize: "container",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      paddingLeft: "30%",
      [theme.breakpoints.down("md")]: {
        paddingLeft: "0",
        padding: "40px",
      },
    },
    imgLogo: {
      width: "60%",
      [theme.breakpoints.down("lg")]: {
        width: "80%",
      },
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
  };
});

export default useStyles;
